import script from "./AppHome.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHome.vue?vue&type=script&setup=true&lang=js"

import "./AppHome.vue?vue&type=style&index=0&id=5daf80b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5daf80b4"]])

export default __exports__